import AppRoutes from "./AppRoutes";
import { createBrowserRouter } from "react-router-dom";
import DefaultLayout from "../components/layouts/DefaultLayout";
import BlankLayout from "../components/layouts/BlankLayout";
import ProtectedRoute from "../features/authentication/ProtectedRoute";

const ApplicationRoutes = AppRoutes.map((route) => {
    return {
        ...route,
        element:
            route.isAuthenticated ?
                (<ProtectedRoute>
                    {route.layout === 'blank' ? <BlankLayout>{route.element}</BlankLayout> : <DefaultLayout>{route.element}</DefaultLayout>}
                </ProtectedRoute>)
                : route.element

    };
});

export const RouteGenerator = createBrowserRouter(ApplicationRoutes);
